import AccordionPanel from '../accordion/panel.vue'

export default AccordionPanel



// WEBPACK FOOTER //
// ./src/components/accordion-panel/index.js